import {makeObservable, observable} from 'mobx';

import type {AnswerModel} from '../Answer/Answer.model';
import type {AssessmentModel} from '../Assessment/Assessment.model';
import type {ModelToProps} from '../Base/types';
import type {DateTimeModel} from '../Date/DateTime.model';
import type {UserModel} from '../User/User.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'BoundAssessmentModel';

export class BoundAssessmentModel extends BaseModel {
  answered?: DateTimeModel;
  answers: Map<string, AnswerModel>;
  assessment: AssessmentModel;
  author: UserModel;
  channelId?: string;
  created: DateTimeModel;
  score: number;
  status: BoundAssessmentModel.Status;
  title: string;
  updated: DateTimeModel;

  constructor(props: BoundAssessmentModel.Props) {
    super(props);

    Object.assign(this, props);

    makeObservable(this, {
      answered: observable,
      score: observable,
      status: observable,
      updated: observable,
    });
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace BoundAssessmentModel {
  export enum Status {
    COMPLETED = 'COMPLETED',
    IN_PROGRESS = 'IN_PROGRESS',
    SENT = 'SENT',
  }
}

export namespace BoundAssessmentModel {
  export type Props = ModelToProps<BoundAssessmentModel>;
}
